import axios from 'axios';

export function getCsrfInfo() {
  return {
    name: document.querySelector('meta[name=csrf-param]').getAttribute('content'),
    token: document.querySelector('meta[name=csrf-token]').getAttribute('content'),
  };
}

// Simula la llamada de remote: true que hace Rails para peticiones GET y que el servidor
// devuelva un javascript que tengamos que interpretar
export function remoteScript(url) {
  const options = {
    headers: {
      Accept: 'text/javascript, application/javascript, application/ecmascript, application/x-ecmascript',
    },
  };
  return axios.get(url, options).then((result) => {
    const nuevoScript = document.createElement('script');
    nuevoScript.innerHTML = result.data;
    document.body.appendChild(nuevoScript);
  });
}

export function contentTypeIsJson(contentType) {
  return contentType?.includes('application/json') || false;
}

/**
 * Waits for the submission result of a form element and returns a promise that resolves
 * if the submission is successful, or rejects if it fails.
 * @param {HTMLFormElement} formElement - The form element to wait for submission result.
 * @returns {Promise} - A promise that resolves with the submission result if successful,
 *  or rejects with the submission result if failed.
 */
export function waitForTurboFormSubmissionResult(formElement) {
  return new Promise((resolve, reject) => {
    const listenerCallback = (event) => {
      if (event.detail.formSubmission.formElement !== formElement) return;

      document.removeEventListener('turbo:submit-end', listenerCallback);

      if (event.detail.success) {
        resolve(event.detail);
      } else {
        reject(event.detail);
      }
    };

    document.addEventListener('turbo:submit-end', listenerCallback);
  });
}

export function formPost(action, params = {}, options = {}) {
  const finalOptions = { overlay: true, ...options };

  const csrfName = document.querySelector('meta[name=csrf-param]')?.getAttribute('content');
  const csrf = document.querySelector('meta[name=csrf-token]')?.getAttribute('content');
  const form = document.createElement('form');
  form.method = 'post';
  form.action = action;
  if (finalOptions.target) {
    form.target = finalOptions.target;
  }

  if (csrfName && csrf) {
    const csrfField = document.createElement('input');
    csrfField.type = 'hidden';
    csrfField.name = csrfName;
    csrfField.value = csrf;
    form.appendChild(csrfField);
  }

  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((val) => {
        const hiddenField = document.createElement('input');
        hiddenField.type = 'hidden';
        hiddenField.name = `${key}[]`;
        hiddenField.value = val;
        form.appendChild(hiddenField);
      });
    } else {
      const hiddenField = document.createElement('input');
      hiddenField.type = 'hidden';
      hiddenField.name = key;
      hiddenField.value = value;
      form.appendChild(hiddenField);
    }
  });

  document.body.appendChild(form);

  if (typeof finalOptions.overlay === 'string') {
    // eslint-disable-next-line no-undef
    new Cifra.Components.Overlay(finalOptions.overlay).show();
  } else if (finalOptions.overlay) {
    // eslint-disable-next-line no-undef
    new Cifra.Components.Overlay('body').show();
  }
  form.submit();
}
